export function sortListFuzzily(list, properties, query) {
  if (!query) return list;
  const normalizedQuery = query.trim().toLowerCase();

  return [...list]
    .filter(item =>
      properties.some(prop => {
        const value = (item[prop] || "").toString().toLowerCase().replace(/\s+/g, " ").trim();
        return value.includes(normalizedQuery);
      })
    )
    .sort((a, b) => {
      const score = item => {
        return Math.max(
          ...properties.map(prop => {
            const value = (item[prop] || "").toString().toLowerCase().replace(/\s+/g, " ").trim();

            if (value === normalizedQuery) return 5;
            if (value.startsWith(normalizedQuery)) return 4;
            if (value.includes(normalizedQuery)) return 3;
            if (normalizedQuery.split(" ").every(q => value.includes(q))) return 2;
            return 0;
          })
        );
      };

      const scoreA = score(a);
      const scoreB = score(b);

      if (scoreA !== scoreB) return scoreB - scoreA;

      // 🔥 Tie-breaker: shorter match length wins
      const lengthA = Math.min(
        ...properties.map(prop => (itemMatchLength(a[prop], normalizedQuery)))
      );
      const lengthB = Math.min(
        ...properties.map(prop => (itemMatchLength(b[prop], normalizedQuery)))
      );

      if (lengthA !== lengthB) return lengthA - lengthB;

      // fallback to alphabetical
      const valA = properties.map(p => a[p] || "").join(" ");
      const valB = properties.map(p => b[p] || "").join(" ");
      return valA.localeCompare(valB);
    });
}

// helper for how close the match is (shorter = better)
function itemMatchLength(value, query) {
  if (!value) return Infinity;
  const val = value.toString().toLowerCase();
  const idx = val.indexOf(query);
  return idx === -1 ? Infinity : val.length;
}
